import SellerApi from '../SellerApi'
import { TBillingDetails, TSubscriptionInfo } from '@valuecase/common'

export default {
  createCustomerPortalSession: async () => {
    const res = await SellerApi.post<{ payload: { url: string } }>(
      '/billing/customer-portal',
      undefined,
    )
    return res.data
  },

  upsertBillingDetails: (tenantId: string, billingDetails: TBillingDetails) =>
    SellerApi.post<undefined, undefined, TBillingDetails>(
      `/billing/${encodeURIComponent(tenantId)}`,
      billingDetails,
    ),

  getSubscriptionInfo: async () => {
    const res = await SellerApi.get<{ payload: TSubscriptionInfo | null }>(
      '/billing/subscription-info',
      undefined,
    )
    return res.data
  },
}
